import { createFileRoute, redirect } from "@tanstack/react-router";

// Old URL: kept so bookmarks and links land on the matching settings tab.
export const Route = createFileRoute("/$store/_layout/settings_/payment")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/$store/settings",
			params: { store: params.store },
			search: { aba: "pagamentos" },
			replace: true,
		});
	},
});
